import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const authzPermissionGroupMappingMenuRegistry = {
    core_authzPermissionGroupMapping: {
        label: "Authz Permission Group Mapping",
        link: PAGE_URL.AUTHZ_PERMISSION_GROUP_MAPPING_PAGE,
        key: PAGE_URL.AUTHZ_PERMISSION_GROUP_MAPPING_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default authzPermissionGroupMappingMenuRegistry;
